import { type InputHTMLAttributes } from 'react'
import styles from './ToggleSwitch.module.css'

type ToggleSwitchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string
  rootClassName?: string
}

export const ToggleSwitch = ({
  className,
  label,
  rootClassName,
  ...props
}: ToggleSwitchProps) => (
  <label className={[styles.root, rootClassName].filter(Boolean).join(' ')} aria-label={label}>
    <input className={[styles.input, className].filter(Boolean).join(' ')} type="checkbox" {...props} />
    <span className={styles.track} />
  </label>
)
